module.exports = __webpack_public_path__ + "assets/ea58b2989a60347793c5746d5d95bb22.jpg";